export default "__VITE_ASSET__4fed8925__"